import {Component, Input, Output, EventEmitter, ViewChild, OnInit} from '@angular/core';
import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";
import {ConstantsService} from "../../../../services/constants/constants.service";
import * as _ from 'lodash';
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-edit-background-recipient',
  templateUrl: './edit-background-recipient.component.pug',
  styleUrls: ['./edit-background-recipient.component.scss'],
  standalone: false
})
export class EditBackgroundRecipientComponent implements OnInit {
  @Input() recipientToEdit: any = null;
  @Input() backgroundCheck: any;
  @Input() backgroundChecks: any;
  @Input() flowsSelected: any[] = [];
  @Input() disable_edit = false;
  @Output() closeEditEvent = new EventEmitter();
  @Output() updatedRecipient = new EventEmitter();
  recipientRow: any = {};
  closeComponent = false;
  disableSend = true;
  @ViewChild("editBackgroundRecipientForm") editRecipient: any;
  phoneUtil = PhoneNumberUtil.getInstance();
  status_label = '';
  employment_type = '';
  employmentSectorDropDownOptions = ConstantsService.EMPLOYMENT_SECTOR
  employmentTypeDropDownOptions = ConstantsService.EMPLOYMENT_TYPE
  acicBackgroundCheck = ConstantsService.ACIC_SHORT_NAME;
  ukdbsBackgroundCheck = ConstantsService.UKDBSC_SHORT_NAME;
  nccpcBackgroundCheck = ConstantsService.NCC_PC_SHORT_NAME;
  nccbankruptcyBackgroundCheck = ConstantsService.NCC_BANKRUPTCY_SHORT_NAME;
  amlBackgroundCheck = ConstantsService.AML_SHORT_NAME;
  bannedBackgroundCheck = ConstantsService.BANNED_SHORT_NAME;
  birthYearPlaceHolder = ConstantsService.BIRTH_YEAR_PLACEHOLDER;
  countryItems:any = []
  countryPlaceholder = ConstantsService.AML_COUNTRY_PLACEHOLDER
  selectedItems:any = []
  yearOptions: { key: string; value: string }[] = [];
  fuzzinessToolTip = ConstantsService.FUZZINESS_TOOLTIP
  fuzziness = ''
  fuzzinessOptions: { key: string; value: string }[] = ConstantsService.FUZZINESSOPTIONS;
  birthYear = "";
  //validation for check names with additional fields
  checkNames = {
    [this.acicBackgroundCheck]: ['role', 'hiring_organisation'],
    [this.ukdbsBackgroundCheck]: ['role', 'employment_sector'],
    [this.nccpcBackgroundCheck]: ['reason', 'place_work', 'type'],
  };
  cvsqBackgroundCheck = ConstantsService.CV_SQ_SHORT_NAME;
  edusqBackgroundCheck = ConstantsService.EDUV_SQ_SHORT_NAME;

  empsqBackgroundCheck = ConstantsService.EMPV_SQ_SHORT_NAME;
  empcpBackgroundCheck = ConstantsService.EMPV_CP_SHORT_NAME;
  flowShortNames: any = [];
  errorMessage = {
    'type': '',
    'message': ''
  };
  selectType = $localize`Select type`;
  selectedChecksMap = {
    [ConstantsService.ACIC_SHORT_NAME]: false,
    [ConstantsService.UKDBSC_SHORT_NAME]: false,
    [ConstantsService.NCC_PC_SHORT_NAME]: false,
    [ConstantsService.NCC_BANKRUPTCY_SHORT_NAME]: false,
    [ConstantsService.AML_SHORT_NAME]: false,
    [ConstantsService.BANNED_SHORT_NAME]: false,
    [ConstantsService.CV_SHORT_NAME]: false,
    [ConstantsService.CV_SQ_SHORT_NAME]: false,
    [ConstantsService.CV_HL_SHORT_NAME]: false,
    [ConstantsService.EDUV_SHORT_NAME]: false,
    [ConstantsService.EDUV_SQ_SHORT_NAME]: false,
    [ConstantsService.EDUV_HL_SHORT_NAME]: false,
    [ConstantsService.EMPV_SHORT_NAME]: false,
    [ConstantsService.EMPV_CP_SHORT_NAME]: false,
    [ConstantsService.EMPV_SQ_SHORT_NAME]: false,
    [ConstantsService.SMC_SHORT_NAME]: false,
    [ConstantsService.EIVC_SHORT_NAME]: false,
  }
  employmentCoverage = '5'
  verificationEmpMin = '2'
  verificationEmpMax = '3'
  verificationQualMin = '1'
  verificationQualMax = '3'
  verificationCredMin = '1'
  verificationCredMax = '3'
  employmentcoverages = _.cloneDeep(ConstantsService.EMPLOYMENT_COVERAGE);
  employmentQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  employmentQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  roleReason: string = '';
  hiringOrganisation: string = '';
  ENT_8918_MULTIPLE_BC = false;
  TRUST_752_VERIFICATION = false;
  TRUST_920_NCC_TYPE = false;

  constructor(private permissions: PermissionsService) {
    this.ENT_8918_MULTIPLE_BC = this.permissions.isFeatureActivated('ent_8918_multiple_bg_checks');
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
    this.TRUST_920_NCC_TYPE = this.permissions.isFeatureActivated('trust-920-ncc-type');
    this.countryItems = _.cloneDeep(ConstantsService.COUNTRY_ALPHA_CODES)
    this.checkNames = {
        ...this.checkNames,
        [this.nccbankruptcyBackgroundCheck]: ['reason', 'place_work', 'type'],
    };
    if (this.TRUST_752_VERIFICATION) {
      this.checkNames = {
        ...this.checkNames,
        [this.cvsqBackgroundCheck]: ['verification_cred_min', 'verification_cred_max'],
        [this.edusqBackgroundCheck]: ['verification_qual_min', 'verification_qual_max'],
        [this.empsqBackgroundCheck]: ['verification_emp_min', 'verification_emp_max'],
        [this.empcpBackgroundCheck]: ['verification_years']
      };
    }
  }

  ngOnInit(): void {
    if (this.TRUST_752_VERIFICATION){
        this.recipientRow = this.recipientToEdit?.recipient ? _.cloneDeep(this.recipientToEdit.recipient) : {};
    }
    else{
        this.recipientRow = _.cloneDeep(this.recipientToEdit['recipient']);
    }

    if(this.ENT_8918_MULTIPLE_BC){
      this.backgroundChecks?.forEach(checkShortName => {
        if (this.selectedChecksMap && checkShortName in this.selectedChecksMap)
          this.selectedChecksMap[checkShortName] = true;
      })
    }

    if(this.TRUST_752_VERIFICATION){
        if(this.flowsSelected.length){
            this.flowShortNames = this.flowsSelected.map(check => check.short_name)
            this.flowShortNames?.forEach(checkShortName => {
                if (this.selectedChecksMap && checkShortName in this.selectedChecksMap)
                  this.selectedChecksMap[checkShortName] = true;
            })
        }
        if(this.selectedChecksMap[this.empcpBackgroundCheck]){
            this.employmentCoverage = this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME].verification_years || this.employmentCoverage
            if(!this.recipientRow?.checks?.[ConstantsService.EMPV_SHORT_NAME]?.verification_years){
                this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME].verification_years = this.employmentCoverage
            }
        }
        if(this.selectedChecksMap[this.empsqBackgroundCheck]){
            this.verificationEmpMin = this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME].verification_emp_min || this.verificationEmpMin
            this.verificationEmpMax = this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME].verification_emp_max || this.verificationEmpMax
            if(!this.recipientRow?.checks?.[ConstantsService.EMPV_SHORT_NAME]?.verification_emp_min){
                this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME].verification_emp_min = this.verificationEmpMin
            }
            if(!this.recipientRow?.checks?.[ConstantsService.EMPV_SHORT_NAME]?.verification_emp_max){
                this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME].verification_emp_max = this.verificationEmpMax
            }
        }
        if(this.selectedChecksMap[this.cvsqBackgroundCheck]){
            this.verificationCredMin = this.recipientRow.checks[ConstantsService.CV_SHORT_NAME].verification_cred_min || this.verificationCredMin
            this.verificationCredMax = this.recipientRow.checks[ConstantsService.CV_SHORT_NAME].verification_cred_max || this.verificationCredMax
            if(!this.recipientRow?.checks?.[ConstantsService.CV_SHORT_NAME]?.verification_cred_min){
                this.recipientRow.checks[ConstantsService.CV_SHORT_NAME].verification_cred_min = this.verificationCredMin
            }
            if(!this.recipientRow?.checks?.[ConstantsService.CV_SHORT_NAME]?.verification_cred_max){
                this.recipientRow.checks[ConstantsService.CV_SHORT_NAME].verification_cred_max = this.verificationCredMax
            }
        }
        if(this.selectedChecksMap[this.edusqBackgroundCheck]){
            this.verificationQualMin = this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME].verification_qual_min || this.verificationQualMin
            this.verificationQualMax = this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME].verification_qual_max || this.verificationQualMax
            if(!this.recipientRow?.checks?.[ConstantsService.EDUV_SHORT_NAME]?.verification_qual_min){
                this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME].verification_qual_min = this.verificationQualMin
            }
            if(!this.recipientRow?.checks?.[ConstantsService.EDUV_SHORT_NAME]?.verification_qual_max){
                this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME].verification_qual_max = this.verificationQualMax
            }
        }
    }

    if(
      (this.ENT_8918_MULTIPLE_BC && (this.selectedChecksMap[this.amlBackgroundCheck])) ||
      (!this.ENT_8918_MULTIPLE_BC && (this.backgroundCheck === this.amlBackgroundCheck))
    )
    {
      if(this.recipientRow['country_codes']){
        this.selectedItems = this.countryItems.filter(country =>
          this.recipientRow['country_codes'].includes(country.value)
        )
        this.countryItems = this.countryItems.map(country => ({
          ...country,
          checked: this.recipientRow['country_codes'].includes(country.value)
        }));
      }

      let option:any;
      if(this.ENT_8918_MULTIPLE_BC)
        option = this.fuzzinessOptions.find(opt => opt.key === this.recipientRow.checks[this.amlBackgroundCheck].fuzziness);
      else
        option = this.fuzzinessOptions.find(opt => opt.key === this.recipientRow.checks[this.backgroundCheck].fuzziness);

      this.fuzziness = option?.value || '';
      this.birthYear = this.recipientRow['birth_year']
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= 1870; year--) {
        this.yearOptions.push({
          key: year.toString(),
          value: year.toString(),
        });
      }
    }

    if(this.ENT_8918_MULTIPLE_BC && this.selectedChecksMap[this.ukdbsBackgroundCheck])
      this.status_label = this.recipientToEdit?.recipient?.checks[this.ukdbsBackgroundCheck]?.employment_sector;
    if(!this.ENT_8918_MULTIPLE_BC && this.backgroundCheck === this.ukdbsBackgroundCheck){
      this.status_label = this.recipientToEdit?.recipient?.checks[this.backgroundCheck]?.employment_sector;
    }

    if(!this.ENT_8918_MULTIPLE_BC && (this.backgroundCheck == this.nccpcBackgroundCheck || (this.backgroundCheck == this.nccbankruptcyBackgroundCheck))){
      const employmentType = this.employmentTypeDropDownOptions.find(type => type.key === this.recipientToEdit?.recipient?.checks[this.backgroundCheck]?.type);
      this.employment_type = employmentType ? employmentType.value : '';
    }

    if (this.ENT_8918_MULTIPLE_BC && (this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck]))) {
      const recipientChecks = this.recipientToEdit?.['recipient']?.checks
      const typeField = recipientChecks?.[this.nccpcBackgroundCheck]?.type || recipientChecks?.[this.nccbankruptcyBackgroundCheck]?.type
      const employmentType = this.employmentTypeDropDownOptions.find(type => type.key === typeField);

      if(this.TRUST_920_NCC_TYPE){
          this.employment_type = employmentType ? employmentType.value : this.employmentTypeDropDownOptions[0].value;
          this.recipientRow['employment_type'] = this.employmentTypeDropDownOptions[0].key;
      }
      else {
          this.employment_type = employmentType ? employmentType.value : '';
      }
    }

    if(this.ENT_8918_MULTIPLE_BC){
      // pre-populate field values
      Object.keys(this.selectedChecksMap).forEach(checkShortName => {
        const recipientCheck = this.recipientRow?.checks?.[checkShortName]
        // Skip soft deleted checks
        if (recipientCheck == undefined || recipientCheck?.is_deleted === true)
          return

        const isNCC = (checkShortName == this.nccpcBackgroundCheck || checkShortName == this.nccbankruptcyBackgroundCheck)
        let roleReasonField = isNCC ? 'reason' : 'role'
        let hiringOrgField = isNCC ? 'place_work' : 'hiring_organisation'

        if (recipientCheck?.[roleReasonField] !== undefined && recipientCheck?.[roleReasonField] !== '')
          this.roleReason = recipientCheck?.[roleReasonField]

        if (recipientCheck?.[hiringOrgField] !== undefined && recipientCheck?.[hiringOrgField] !== '')
          this.hiringOrganisation = recipientCheck?.[hiringOrgField]

      })
    }

    if (this.recipientRow && !this.recipientRow?.checks) {
      this.recipientRow.checks = {};
      if(this.ENT_8918_MULTIPLE_BC){
        this.backgroundChecks.forEach(bgCheck => {
          if (!this.recipientRow.checks[bgCheck]) {
            this.recipientRow.checks[bgCheck] = {
              reason: '',
              place_work: '',
              type: '',
              role: '',
              hiring_organisation: '',
            };
          }
        })
      }

      if (!this.ENT_8918_MULTIPLE_BC && !this.recipientRow.checks[this.backgroundCheck]) {
        this.recipientRow.checks[this.backgroundCheck] = {
          reason: '',
          place_work: '',
          type: '',
          role: '',
          hiring_organisation: '',
        };
      }
    }

    if(this.TRUST_920_NCC_TYPE){
        if(this.selectedChecksMap[this.nccpcBackgroundCheck])
            this.recipientRow['checks'][this.nccpcBackgroundCheck]['type'] = this.employmentTypeDropDownOptions[0].key;
        if(this.selectedChecksMap[this.nccbankruptcyBackgroundCheck])
            this.recipientRow['checks'][this.nccbankruptcyBackgroundCheck]['type'] = this.employmentTypeDropDownOptions[0].key;
    }
    this.disableCheck();
    if(this.TRUST_752_VERIFICATION){
        if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow?.email && this.recipientRow?.mobile_phone) {
          // Use setTimeout to ensure the form is initialized
          setTimeout(() => {
            if (this.editRecipient && this.editRecipient.control) {
              this.editRecipient.control.markAsDirty();
            }
          }, 0);
        }
    }
    // Mark form as dirty if we have valid data to enable save button

  }

  isSaveDisabled(): boolean {
    if (!this.ENT_8918_MULTIPLE_BC){
      if(this.backgroundCheck === this.nccpcBackgroundCheck || (this.backgroundCheck == this.nccbankruptcyBackgroundCheck)){
        return this.disableSend || this.recipientRow?.checks?.[this.backgroundCheck].reason.length > 100 || this.recipientRow?.checks?.[this.backgroundCheck].place_work.length > 100;
      }
      else if (this.backgroundCheck === this.acicBackgroundCheck || this.backgroundCheck === this.ukdbsBackgroundCheck) {
        return this.disableSend || this.recipientRow?.checks?.[this.backgroundCheck].role.length > 255;
      } else {
        return this.disableSend;
      }
    } else {
      if(this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck])){
        const recipientChecks = this.recipientRow?.checks
        const reasonLength = (recipientChecks?.[this.nccpcBackgroundCheck]?.reason?.length > 100) || (recipientChecks?.[this.nccbankruptcyBackgroundCheck]?.reason?.length > 100)
        const placeWorkLength = (recipientChecks?.[this.nccpcBackgroundCheck]?.place_work?.length > 100) || (recipientChecks?.[this.nccbankruptcyBackgroundCheck]?.place_work?.length > 100)
        return this.disableSend || reasonLength || placeWorkLength
      }
      else if (this.selectedChecksMap[this.acicBackgroundCheck]) {
        return this.disableSend || this.recipientRow?.checks?.[this.acicBackgroundCheck]?.role?.length > 255;
      } if (this.selectedChecksMap[this.ukdbsBackgroundCheck]){
        return this.disableSend || this.recipientRow?.checks?.[this.ukdbsBackgroundCheck]?.role?.length > 255;
      }
      else {
        return this.disableSend;
      }
    }
  }

  closeEdit() {
    this.closeComponent = true;
    this.closeEditEvent.emit(this.closeComponent);
  }

  disableCheck() {
    if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow?.email && this.recipientRow?.mobile_phone) {
      this.checkRequiredFieldsForCheckName();
    } else this.disableSend = true;
  }

  disableCheckAndCheckRoleLength() {
    // Validate the role length
    if (this.recipientRow?.checks?.[this.backgroundCheck].role.length > 255) {
      this.disableSend = true;
    }
    if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow?.email && this.recipientRow?.mobile_phone) {
      this.checkRequiredFieldsForCheckName();
    } else this.disableSend = true;
  }

  disableCheckAndCheckReasonLength() {
    if (this.recipientRow?.checks?.[this.backgroundCheck].reason.length > 100) {
      this.disableSend = true;
    }
    if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow?.email && this.recipientRow?.mobile_phone) {
      this.checkRequiredFieldsForCheckName();
    } else this.disableSend = true;
  }

  disableCheckAndCheckRoleReasonLength() {
    Object.keys(this.selectedChecksMap).forEach(key => {
      const isNCC = (key == this.nccpcBackgroundCheck || key == this.nccbankruptcyBackgroundCheck)
      let fieldName = isNCC ? 'reason' : 'role'
      if(this.selectedChecksMap[key])
        this.recipientRow.checks[key][fieldName] = this.roleReason
    })

    // Validate the role length
    if (
      this.recipientRow?.checks?.[this.acicBackgroundCheck]?.role?.length > 255 ||
      this.recipientRow?.checks?.[this.ukdbsBackgroundCheck]?.role?.length > 255 ||
      this.recipientRow?.checks?.[this.nccpcBackgroundCheck]?.reason?.length > 100 ||
      this.recipientRow?.checks?.[this.nccbankruptcyBackgroundCheck]?.reason?.length > 100
    ) {
      this.disableSend = true;
    }
    this.disableCheck();
  }

  disableCheckAndCheckPlaceWorkLength() {
    if(this.ENT_8918_MULTIPLE_BC){
      Object.keys(this.selectedChecksMap).forEach(key => {
        const isNCC = (key == this.nccpcBackgroundCheck || key == this.nccbankruptcyBackgroundCheck)
        let fieldName = isNCC ? 'place_work' : 'hiring_organisation'
        if(this.selectedChecksMap[key])
          this.recipientRow.checks[key][fieldName] = this.hiringOrganisation
      })

      if (this.recipientRow?.checks?.[this.nccpcBackgroundCheck]?.place_work?.length > 100) {
        this.disableSend = true;
      }
      this.disableCheck();
    }

    if(!this.ENT_8918_MULTIPLE_BC){
      if (this.recipientRow?.checks?.[this.backgroundCheck].place_work.length > 100) {
        this.disableSend = true;
      }
      if (this.recipientRow.first_name?.trim() && this.recipientRow?.last_name.trim() && this.recipientRow?.email && this.recipientRow?.mobile_phone) {
        this.checkRequiredFieldsForCheckName();
      } else this.disableSend = true;
    }
  }

  checkRequiredFieldsForCheckName(){
    if(this.TRUST_752_VERIFICATION){
      for (const checkShortName of this.backgroundChecks) {
        let fieldsToCheck = this.checkNames[checkShortName];
        if(!fieldsToCheck) {
            const match = this.flowsSelected.find(flow => flow.parent_short === checkShortName);

            const result = match ? match.short_name : null;
            if(result){
                fieldsToCheck = this.checkNames[result];
            }
        }
        if (fieldsToCheck && fieldsToCheck.length > 0) {
          for (const fieldName of fieldsToCheck) {
            if (!this.recipientRow?.checks?.[checkShortName]?.[fieldName] || this.recipientRow?.checks?.[checkShortName]?.[fieldName]?.trim() === '') {
              this.disableSend = true;
              return;
            }
          }
        }
      }
            
      // Always validate min > max for verification types (regardless of selectedChecksMap)
      if (this.verificationQualMin && this.verificationQualMax) {
        if (Number(this.verificationQualMin) > Number(this.verificationQualMax)) {
          this.disableSend = true;
          return;
        }
      }
      if (this.verificationEmpMin && this.verificationEmpMax) {
        if (Number(this.verificationEmpMin) > Number(this.verificationEmpMax)) {
          this.disableSend = true;
          return;
        }
      }
      if (this.verificationCredMin && this.verificationCredMax) {
        if (Number(this.verificationCredMin) > Number(this.verificationCredMax)) {
          this.disableSend = true;
          return;
        }
      }
      
      this.disableSend = false;
    }
    else{
        if(this.ENT_8918_MULTIPLE_BC){
          for (const checkShortName of this.backgroundChecks) {
            const fieldsToCheck = this.checkNames[checkShortName];
            if (fieldsToCheck && fieldsToCheck.length > 0) {
              for (const fieldName of fieldsToCheck) {
                if (!this.recipientRow?.checks?.[checkShortName]?.[fieldName] || this.recipientRow?.checks?.[checkShortName]?.[fieldName]?.trim() === '') {
                  this.disableSend = true;
                  return;
                }
              }
            }
          }
          this.disableSend = false;
        }

        if(!this.ENT_8918_MULTIPLE_BC){
          const fieldsToCheck = this.checkNames[this.backgroundCheck];
          if (fieldsToCheck && fieldsToCheck.length > 0) {
            for (const fieldName of fieldsToCheck) {
              if (!this.recipientRow?.checks?.[this.backgroundCheck]?.[fieldName] || this.recipientRow?.checks?.[this.backgroundCheck]?.[fieldName]?.trim() === '') {
                this.disableSend = true;
                return;
              }
            }
          }
          this.disableSend = false;
        }
    }
  }

  saveDetails(recipient) {
    if(this.TRUST_752_VERIFICATION){
      this.backgroundChecks.forEach(checkShortName => {
        let fieldsToCheck = this.checkNames[checkShortName];
        if(!fieldsToCheck) {
            const match = this.flowsSelected.find(flow => flow.parent_short === checkShortName);

            const result = match ? match.short_name : null;
            if(result){
                fieldsToCheck = this.checkNames[result];
            }
        }
        if (fieldsToCheck && fieldsToCheck.length > 0) {
          for (const fieldName of fieldsToCheck) {
            if (this.recipientRow?.checks?.[checkShortName]?.[fieldName] || this.recipientRow?.checks?.[checkShortName]?.[fieldName]?.trim() !== '') {
              recipient[fieldName] = this.recipientRow?.checks?.[checkShortName]?.[fieldName]
            }
          }
        }
      })
    }
    else{
        if(this.ENT_8918_MULTIPLE_BC){
          this.backgroundChecks.forEach(checkShortName => {
            const fieldsToCheck = this.checkNames[checkShortName];
            if (fieldsToCheck && fieldsToCheck.length > 0) {
              for (const fieldName of fieldsToCheck) {
                if (this.recipientRow?.checks?.[checkShortName]?.[fieldName] || this.recipientRow?.checks?.[checkShortName]?.[fieldName]?.trim() !== '') {
                  recipient[fieldName] = this.recipientRow?.checks?.[checkShortName]?.[fieldName]
                }
              }
            }
          })
        }

        if(!this.ENT_8918_MULTIPLE_BC){
          const fieldsToCheck = this.checkNames[this.backgroundCheck];
          if (fieldsToCheck && fieldsToCheck.length > 0) {
            for (const fieldName of fieldsToCheck) {
              if (this.recipientRow?.checks[this.backgroundCheck][fieldName] || this.recipientRow?.checks[this.backgroundCheck][fieldName]?.trim() !== '') {
                recipient[fieldName] = this.recipientRow?.checks[this.backgroundCheck][fieldName]
              }
            }
          }
        }
    }

    let payloadToEdit = {
      "recipient": recipient,
    }
    if (recipient['first_name'] && recipient['last_name'] && recipient['email'] && this.recipientRow['mobile_phone']) {
      this.checkRequiredFieldsForCheckName();
      this.updatedRecipient.emit(payloadToEdit);
      this.closeEdit();
    }
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return 'none';
  }

  phoneUpdate(event) {
    if(event.country_code.trim() && event.mobile_phone.trim()){
      this.editRecipient.control.markAsDirty();
      this.recipientRow['country_code'] = event['country_code'];
      this.recipientRow['mobile_phone'] = event['mobile_phone'] === 'null' ? '' : event['mobile_phone'];
      let phone = event['country_code'] + event['mobile_phone'];
      let parsedPhone = '';
      try {
        parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
        this.recipientRow['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
      } catch (e) {
        console.log("Phone number parsing error: ", e);
      }
      this.disableCheck();
    } else {
      this.disableSend = true;
    }
  }

  dropDownOptionSelected(sector) {
    this.editRecipient.control.markAsDirty();
    this.recipientRow['employment_sector'] = sector.value;
    if(this.ENT_8918_MULTIPLE_BC)
      this.recipientRow['checks'][this.ukdbsBackgroundCheck]['employment_sector'] = sector.value;
    else
      this.recipientRow['checks'][this.backgroundCheck]['employment_sector'] = sector.value;
    this.disableCheck();
  }

  employmentTypeOptionSelected(sector) {
    this.editRecipient.control.markAsDirty();
    this.recipientRow['employment_type'] = sector.key;

    if(this.ENT_8918_MULTIPLE_BC){
      if(this.selectedChecksMap[this.nccpcBackgroundCheck])
        this.recipientRow['checks'][this.nccpcBackgroundCheck]['type'] = sector.key;

      if(this.selectedChecksMap[this.nccbankruptcyBackgroundCheck])
        this.recipientRow['checks'][this.nccbankruptcyBackgroundCheck]['type'] = sector.key;
    }
    else
      this.recipientRow['checks'][this.backgroundCheck]['type'] = sector.key;

    this.disableCheck();
  }

  selectedItemsEmitter($event){
    this.selectedItems = $event;
    this.recipientRow['country_codes'] = $event.map(item => item.value);
    this.editRecipient.control.markAsDirty();
    this.disableCheck();

  }

  updateYear(year) {
    this.recipientRow['birth_year'] = year.value;
    this.editRecipient.control.markAsDirty();
    this.disableCheck();
  }

  updatefuzziness(fuziness) {
    this.recipientRow['fuzziness'] = fuziness.key;
    this.fuzziness = fuziness.value;
    this.editRecipient.control.markAsDirty();
    this.disableCheck();
  }

  isBackgroundCheckSelected(checks) {
      if (this.TRUST_752_VERIFICATION) {
          return checks.some(bgCheck => this.backgroundChecks.includes(bgCheck)) || checks.some(bgCheck => this.flowShortNames.includes(bgCheck))
      }
      else {
          return checks.some(bgCheck => this.backgroundChecks.includes(bgCheck))
      }

  }
  employmentCoverageSelected(sector) {
    this.employmentCoverage = sector.value;
    this.recipientRow['verification_years'] = sector.value;
    this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME]['verification_years'] = sector.value;
    this.editRecipient.control.markAsDirty();
    this.disableCheck();
  }

  eduQualSelected(sector: any, type) {
      if(type==='min'){
          this.verificationQualMin = sector.value
          this.recipientRow['verification_qual_min'] = sector.value;
          this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME]['verification_qual_min'] = sector.value;
      }
      else if(type=='max'){
        this.verificationQualMax = sector.value;
        this.recipientRow['verification_qual_max'] = sector.value;
        this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME]['verification_qual_max'] = sector.value;
      }
      if (!this.recipientRow?.checks?.[ConstantsService.EDUV_SHORT_NAME]?.['verification_qual_max']) {
          this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME]['verification_qual_max'] = this.verificationQualMax
      }
      if (!this.recipientRow?.checks?.[ConstantsService.EDUV_SHORT_NAME]?.['verification_qual_min']) {
          this.recipientRow.checks[ConstantsService.EDUV_SHORT_NAME]['verification_qual_min'] = this.verificationQualMin
      }
      if(Number(this.verificationQualMin) > Number(this.verificationQualMax)){
          this.disableSend = true
      }
      this.editRecipient.control.markAsDirty();
      this.disableCheck();
  }

  employmentQualSelected(sector: any, type) {
      if(type==='min'){
          this.verificationEmpMin = sector.value
          this.recipientRow['verification_emp_min'] = sector.value;
          this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME]['verification_emp_min'] = sector.value;
      }
      else if(type=='max'){
        this.verificationEmpMax = sector.value;
        this.recipientRow['verification_emp_max'] = sector.value;
        this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME]['verification_emp_max'] = sector.value;
      }
      if (!this.recipientRow?.checks?.[ConstantsService.EMPV_SHORT_NAME]?.['verification_emp_max']) {
          this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME]['verification_emp_max'] = this.verificationEmpMax
      }
      if (!this.recipientRow?.checks?.[ConstantsService.EMPV_SHORT_NAME]?.['verification_emp_min']) {
          this.recipientRow.checks[ConstantsService.EMPV_SHORT_NAME]['verification_emp_min'] = this.verificationEmpMin
      }
      if(Number(this.verificationEmpMin) > Number(this.verificationEmpMax)){
          this.disableSend = true
      }
      this.editRecipient.control.markAsDirty();
      this.disableCheck();
  }

  credQualSelected(sector: any, type) {
      if(type==='min'){
          this.verificationCredMin = sector.value
          this.recipientRow['verification_cred_min'] = sector.value;
          this.recipientRow.checks[ConstantsService.CV_SHORT_NAME]['verification_cred_min'] = sector.value;
      }
      else if(type=='max'){
        this.verificationCredMax = sector.value;
        this.recipientRow['verification_cred_max'] = sector.value;
        this.recipientRow.checks[ConstantsService.CV_SHORT_NAME]['verification_cred_max'] = sector.value;
      }
      if (!this.recipientRow?.checks?.[ConstantsService.CV_SHORT_NAME]?.['verification_cred_max']) {
          this.recipientRow.checks[ConstantsService.CV_SHORT_NAME]['verification_cred_max'] = this.verificationCredMax
      }
      if (!this.recipientRow?.checks?.[ConstantsService.CV_SHORT_NAME]?.['verification_cred_min']) {
          this.recipientRow.checks[ConstantsService.CV_SHORT_NAME]['verification_cred_min'] = this.verificationCredMin
      }
      if(Number(this.verificationCredMin) > Number(this.verificationCredMax)){
          this.disableSend = true
      }
      this.editRecipient.control.markAsDirty();
      this.disableCheck();
  }

}
